

import React, { useEffect, useState } from 'react';
import NavbarBottom from '../components/NavbarBottom';
import 'swiper/css';
import { useNavigate, useLocation } from 'react-router-dom';

import { Swiper, SwiperSlide } from 'swiper/react';
import { getVideosFirebase , updateExpired } from '../Firebase'
import checkmark from '../assets/check_mark_icon.svg'
import playIcon from '../assets/play-button_2.svg';
import NotFound from '../assets/Group 21437.svg'
import logo from '../assets/logo.png'


export default function History() {
  const navigate = useNavigate();
  const location = useLocation(); // Get passed props

  // Default to "talking_photo" if no prop is provided
  const initialPill = location.state?.selectedPill || 'talking_photo';

  const [selectedPill, setSelectedPill] = useState(initialPill);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const userdata = JSON.parse(sessionStorage.getItem('AI_UserData'));
  const uuid = userdata.uuid;

  const handleSelectPill = (pill) => {
    setLoading(true);
    setSelectedPill(pill);
    getVideosFirebase(pill, uuid).then((response) => {
      setData(response);
      console.log(response);
      setLoading(false);
    });
    console.log(pill);
  };

  useEffect(() => {

    setLoading(true);

    getVideosFirebase(selectedPill, uuid).then((response) => {
      setData(response);
      setLoading(false);


      Object.entries(response).forEach(([key, value]) => {
        if(value.video_url && checkExpiration(value.video_url)){
          updateExpired(selectedPill, uuid, key)
        }else{
          console.log("Everything is up tod at")
        }
        
      });

    });



  }, [selectedPill]); // Re-fetch when the selected pill changes



  const ViewVideo = (videourl, id) => {
    console.log(selectedPill)
    navigate(`/Portal/generatedvideo`, { state: { videourl, id, uuid, selectedPill } });
  };



  function checkExpiration(url) {
    const urlObj = new URL(url);
    const exp_date = urlObj.searchParams.get("Expires");

    const now = Math.floor(Date.now() / 1000); // Get current time in seconds
    return exp_date < now; // Check if the timestamp is in the past
  
  }




  return (
    <>
      <h1 className='container pt-4 mb-2'>History</h1>

      <Swiper
        className='ma-container m-0'
        data-aos='fade-down'
        spaceBetween={5}
        slidesPerView={'auto'}
        navigation
        onSwiper={(swiper) => {
          if (selectedPill !== null) {
            const index = swiper.slides.findIndex(
              (slide) => slide.innerText === selectedPill
            );
            if (index !== -1) swiper.slideTo(index);
          }
        }}
      >
        <SwiperSlide
          className={`pill ${selectedPill === 'talking_photo' ? 'selected' : ''}`}
          onClick={() => handleSelectPill('talking_photo')}
        >
          Talking Photo
        </SwiperSlide>

        <SwiperSlide
          className={`pill ${selectedPill === 'avatar' ? 'selected' : ''}`}
          onClick={() => handleSelectPill('avatar')}
        >
          Avatars
        </SwiperSlide>

        {/* <SwiperSlide
          className={`pill ${selectedPill === 'Streaming Avatars' ? 'selected' : ''}`}
          onClick={() => handleSelectPill('Streaming Avatars')}
        >
          Streaming Avatars
        </SwiperSlide> */}
      </Swiper>

      <div className='container mt-5' style={{ marginBottom: '150px' }}>
        {loading ? (
          <span className="Spinloader"></span>
        ) : (!data || data.length === 0) ? (
          <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: '50vh' }}>
            <img src={NotFound} alt="Not Found" />
            <h2>No History Found</h2>
          </div>
        ) : (

          Object.entries(data).map(([key, item], index) => (
            <div key={index} className='d-flex flex-row justify-content-between align-items-center mt-4' style={{ cursor: 'pointer' }}
              onClick={() => ViewVideo(item.video_url, key)} >
              <div className='d-flex align-items-center gap-4'>
                <img
                  style={{ height: '77px', width: '77px', objectFit: 'cover', borderRadius: '1rem' }}
                  src={item.thumbnail_url ? item.thumbnail_url : logo}
                  alt={item.title}
                />
                <div>
                  <h2>{item.title}</h2>
                  {item.status === "completed" ? (
                    <p className='text-dark p-0 m-0'>
                      <img src={checkmark} className='pr-1' alt="checkmark" />
                      Completed
                    </p>
                  ) : (
                    <p className='text-dark p-0 m-0'>Processing ...</p>
                  )}
                </div>
              </div>
              {/* <img
                src={playIcon}
                onClick={() => ViewVideo(item.video_url, key)} // Use 'key' as the id
                style={{
                  background: "white",
                  borderRadius: "50%",
                  width: "26px",
                  cursor: "pointer",
                }}
                alt="Play Icon"
              /> */}
              {item.status === "completed" ? (
                <img src={playIcon}
                  style={{ background: 'white', borderRadius: '50%', width: '26px', cursor: 'pointer' }} alt="Play Icon" />
              ) : (<p style={{ border: '1px solid black', borderRadius: '20px', background: 'black', padding: '5px 15px' }} >Check Status</p>
              )}
            </div>
          ))

        )}
      </div>

      <NavbarBottom />
    </>
  );
}
